export class UserModel {
  public userId: number;
  public name: string;
  public email: string;
  public password: string;
  public confirmPassword: string;
  public birthDate: string;
  public facebookUserId: string;
}